import { render, staticRenderFns } from "./IgmpConfig.vue?vue&type=template&id=7ec2b227&"
import script from "./IgmpConfig.vue?vue&type=script&lang=js&"
export * from "./IgmpConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports